import React, { useState } from 'react'
import numeral from 'numeral'
import _ from 'lodash'
import {
  Div, H4, P, Icon, SmallText, Loading,
} from 'konsys-ui'
import { Row, Col } from 'antd'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { BANKS, PRICINGTYPES, INVENTORY } from '../../../constants/graph/query'
import { theme } from '../../../styles/_variables'
import { Wrapper } from '../../../components/inventory-components'
import {
  LargeTextWithLabel, Tag, Collapse, Divider, ComponentWithLabelLarge,
} from '../../../components/common'
import { Image, PartImage } from '../styled'
import { SALE_TYPE } from '../constants'
import { productGroupIdtoText, stockTypeIdtoText } from '../utils'
import imageNotAvailable from '../../../assets/image-not-available.png'

const Info = ({
  data: {
    sku, supplier, productName, brand, productGroup, category, stockType, barcode, reference, technicianName, unit,
  },
}) => (
  <Div width='100%'>
    <Row type='flex' style={{ margin: '16px 0' }}>
      <Col span={8}>
        <LargeTextWithLabel title={{ text: 'รหัสสินค้า' }} content={{ text: sku || 'ไม่ระบุ' }} />
      </Col>
      <Col span={16}>
        <Div display='flex' flexDirection='column'>
          <SmallText bold>Supplier</SmallText>
          <SmallText>{_.join(supplier.map(v => v.name), ', ')}</SmallText>
        </Div>
        {/* <LargeTextWithLabel title={{ text: 'Supplier' }} content={{ text: supplier.name || 'ไม่ระบุ' }} /> */}
      </Col>
    </Row>
    <Row type='flex' style={{ margin: '16px 0' }}>
      <Col span={8}>
        <LargeTextWithLabel title={{ text: 'ชื่อสินค้า' }} content={{ text: productName || 'ไม่ระบุ' }} />
      </Col>
      <Col span={8}>
        <LargeTextWithLabel title={{ text: 'ชื่อที่ช่างเรียก' }} content={{ text: technicianName || 'ไม่ระบุ' }} />
      </Col>
      <Col span={8}>
        <LargeTextWithLabel title={{ text: 'หน่วย' }} content={{ text: unit || 'ไม่ระบุ' }} />
      </Col>
    </Row>
    <Row type='flex' style={{ margin: '16px 0' }}>
      <Col span={8}>
        <LargeTextWithLabel title={{ text: 'ยื่ห้อ' }} content={{ text: brand || 'ไม่ระบุ' }} />
      </Col>
      <Col span={8}>
        <LargeTextWithLabel title={{ text: 'ประเภทสินค้า' }} content={{ text: productGroupIdtoText(productGroup) || 'ไม่ระบุ' }} />
      </Col>
      <Col span={8}>
        <LargeTextWithLabel title={{ text: 'หมวดหมู่สินค้า' }} content={{ text: category || 'ไม่ระบุ' }} />
      </Col>
    </Row>
    <Row type='flex' style={{ margin: '16px 0' }}>
      <Col span={8}>
        <LargeTextWithLabel title={{ text: 'Ref ID' }} content={{ text: reference || 'ไม่ระบุ' }} />
      </Col>
      <Col span={8}>
        <LargeTextWithLabel title={{ text: 'Barcode' }} content={{ text: barcode || 'ไม่ระบุ' }} />
      </Col>
    </Row>
    <Row type='flex' style={{ margin: '16px 0' }}>
      <Col span={24}>
        <LargeTextWithLabel title={{ text: 'ประเภทสต๊อกสินค้า' }} content={{ text: stockTypeIdtoText(stockType) || 'ไม่ระบุ' }} />
      </Col>
    </Row>
  </Div>
)

const AttributesList = ({
  data: {
    sellable, purchasable, taxable, serialTracking,
  },
}) => (
  <Div>
    <P bold margin='0 0 16px 0'>ข้อมูลเพิ่มเติม</P>
    { sellable && <Div margin='0 0 8px 0'><Icon icon='fal fa-check' color={theme.color.primaryColor} margin='0 8px 0 0' /><P>สามารถขายสินค้าได้</P></Div> }
    { purchasable && <Div margin='0 0 8px 0'><Icon icon='fal fa-check' color={theme.color.primaryColor} margin='0 8px 0 0' /><P>สามารถจัดซื้อสินค้าได้</P></Div> }
    { taxable && <Div margin='0 0 8px 0'><Icon icon='fal fa-check' color={theme.color.primaryColor} margin='0 8px 0 0' /><P>สามารถคิดภาษีสินค้าได้</P></Div> }
    { serialTracking && <Div margin='0 0 8px 0'><Icon icon='fal fa-check' color={theme.color.primaryColor} margin='0 8px 0 0' /><P>ติดตาม Serial Number สินค้า</P></Div> }
    {
      !sellable && !purchasable && !taxable && !serialTracking && <Div margin='0 0 8px 0'><P>-</P></Div>
    }
  </Div>
)

const Tags = ({ data: { tag } }) => (
  <Div>
    <P bold margin='16px 0'>แท็ก</P>
    <Div margin='0 -8px 16px -8px'>
      {
        tag.map(v => <Tag key={v.id} margin='4px 8px' text={v.name} />)
      }
      {
        _.size(tag) < 1 && <P margin='4px 8px'>-</P>
      }
    </Div>
  </Div>
)

const StockCollapse = ({ stockLocations, setIsOpenStock, isOpenStock }) => (
  <Collapse open={isOpenStock} text='สต็อกในแต่ละสถานที่เก็บ' onClick={() => setIsOpenStock(!isOpenStock)} fullHeight={true} margin='8px 0'>
    {
      stockLocations.map((v, i) => (
        <Div key={i} padding='16px' style={{ border: `1px solid ${theme.color.lightBlue}`, borderRadius: 5, background: '#fafafa' }} margin='4px 0 0'>
          <Row key={i} type='flex' style={{ margin: '8px 0' }}>
            <Col span={8} style={{ margin: '0 0 8px 0' }}>
              <LargeTextWithLabel title={{ text: 'สถานที่เก็บ' }} content={{ text: v.warehouse ? v.warehouse.warehouseName : 'ไม่ระบุ', bold: true }} />
            </Col>
            <Col span={8} style={{ margin: '0 0 8px 0' }}>
              <LargeTextWithLabel title={{ text: 'รหัสชั้นวาง' }} content={{ text: v.shelf, bold: true }} />
            </Col>
          </Row>
          <Row>
            <Col span={6} style={{ margin: '0 0 8px 0' }}>
              <ComponentWithLabelLarge title={{ text: 'สินค้าในคลัง' }}>
                <P bold>{v.quantity}</P><P color={theme.color.warning} bold>(+50)</P><P margin='0 0 0 4px'>ชิ้น</P>
              </ComponentWithLabelLarge>
            </Col>
            <Col span={6} style={{ margin: '0 0 8px 0' }}>
              <ComponentWithLabelLarge title={{ text: 'สินค้าที่ขายได้' }}>
                <P color={theme.color.success} bold>{v.quantity}</P><P color={theme.color.info} bold>(+50)</P><P margin='0 0 0 4px'>ชิ้น</P>
              </ComponentWithLabelLarge>
            </Col>
            <Col span={6} style={{ margin: '0 0 8px 0' }}>
              <ComponentWithLabelLarge title={{ text: 'รอรับเข้าคลังเพื่อสต๊อก' }}>
                <P color={theme.color.info} bold>(+{v.quantity})</P><P margin='0 0 0 4px'>ชิ้น</P>
              </ComponentWithLabelLarge>
            </Col>
            <Col span={6} style={{ margin: '0 0 8px 0' }}>
              <ComponentWithLabelLarge title={{ text: 'รอรับเข้าคลังจากใบ SO' }}>
                <P color={theme.color.softPurple} bold>(+{v.quantity})</P><P margin='0 0 0 4px'>ชิ้น</P>
              </ComponentWithLabelLarge>
            </Col>
          </Row>
        </Div>
      ))
    }
  </Collapse>
)

// Variant type
const VariantDetail = ({ data }) => {
  const [isOpenVariant, setIsOpenVariant] = useState(true)
  return (
    <Div>
      <Info data={data} />
      {/* <AttributesList data={data} /> */}
      <Tags data={data} />
      <Collapse open={isOpenVariant} text='รายละเอียดสินค้า' onClick={() => setIsOpenVariant(!isOpenVariant)} fullHeight={true} margin='8px 0'>
        {
          data.inventoryOptions.map((v, i) => (
            <Div key={i}>
              <Div display='flex' justifyContent='space-between' alignItems='center'>
                  <Div display='flex' flexDirection='column' alignItems='flex-start' flexGrow='1'>
                    <H4 bold margin='0 0 8px 0'>
                    {
                      // _.join(_.dropRightWhile([v.option1 && v.option1.optionName, v.option2 && v.option2.optionName, v.option3 && v.option3.optionName], o => _.isNull(o)), ' / ')
                      v.variantName
                    }
                    </H4>
                    <Div type='flex' width='100%'>
                    <Col span={6} style={{ margin: '0 0 8px 0' }}>
                      <LargeTextWithLabel title={{ text: 'รหัสสินค้า' }} content={{ text: v.sku }} />
                      </Col>
                      <Col span={6} style={{ margin: '0 0 8px 0' }}>
                      <LargeTextWithLabel title={{ text: 'จำนวนสินค้า' }} content={{ text: _.sumBy(v.stockLocation, n => (n.quantity)) }} margin='0 40px 0 0'/>
                      </Col>
                      <Col span={6} style={{ margin: '0 0 8px 0' }}>
                      <LargeTextWithLabel title={{ text: 'จำนวนสต๊อกขั้นต่ำ' }} content={{ text: v.minimumStock }} />
                      </Col>
                    </Div>
                    <Div type='flex' width='100%'>
                    <Col span={6} style={{ margin: '0 0 8px 0' }}>
                      <LargeTextWithLabel title={{ text: 'ต้นทุน' }} content={{ text: `${numeral(v.initialCost).format('0,0.00')} บาท` }} />
                      </Col>
                      <Col span={6} style={{ margin: '0 0 8px 0' }}>
                      <LargeTextWithLabel title={{ text: 'ราคาซื้อสุทธิ' }} content={{ text: `${numeral(v.buyPrice).format('0,0.00')} บาท` }} margin='0 40px 0 0'/>
                      </Col>
                      <Col span={6} style={{ margin: '0 0 8px 0' }}>
                      <LargeTextWithLabel title={{ text: 'ราคาขาย' }} content={{ text: `${numeral(v.salesPrice).format('0,0.00')} บาท` }} />
                      </Col>
                    </Div>
                  </Div>
                <Div>
                  <Image src={v.url || imageNotAvailable} alt='' />
                </Div>
              </Div>
              {
                v.stockLocation.map((value, index) => (
                  <Div key={index} padding='16px' style={{ border: `1px solid ${theme.color.lightBlue}`, borderRadius: 5, background: '#fafafa' }} margin='4px 0 0'>
                    <Row key={i} type='flex' style={{ margin: '8px 0' }}>
                      <Col span={8} style={{ margin: '0 0 8px 0' }}>
                        <LargeTextWithLabel title={{ text: 'สถานที่เก็บ' }} content={{ text: value.warehouse ? value.warehouse.warehouseName : 'ไม่ระบุ', bold: true }} />
                      </Col>
                      <Col span={8} style={{ margin: '0 0 8px 0' }}>
                        <LargeTextWithLabel title={{ text: 'รหัสชั้นวาง' }} content={{ text: value.shelf, bold: true }} />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={6} style={{ margin: '0 0 8px 0' }}>
                        <ComponentWithLabelLarge title={{ text: 'สินค้าในคลัง' }}>
                          <P bold>{value.quantity}</P>{value.preorderItemQuantity > 0 && <P margin='0 0 0 8px'>(+{value.preorderItemQuantity})</P>}<P margin='0 0 0 8px'>ชิ้น</P>
                          {/* <P bold>{value.quantity}</P><P color={theme.color.warning} bold>(+50)</P><P margin='0 0 0 4px'>ชิ้น</P> */}
                        </ComponentWithLabelLarge>
                      </Col>
                      {/* <Col span={6} style={{ margin: '0 0 8px 0' }}>
                        <ComponentWithLabelLarge title={{ text: 'สินค้าที่ขายได้' }}>
                          <P color={theme.color.success} bold>{value.quantity}</P><P color={theme.color.info} bold>(+50)</P><P margin='0 0 0 4px'>ชิ้น</P>
                        </ComponentWithLabelLarge>
                      </Col>
                      <Col span={6} style={{ margin: '0 0 8px 0' }}>
                        <ComponentWithLabelLarge title={{ text: 'รอรับเข้าคลังเพื่อสต๊อก' }}>
                          <P color={theme.color.info} bold>(+{value.quantity})</P><P margin='0 0 0 4px'>ชิ้น</P>
                        </ComponentWithLabelLarge>
                      </Col>
                      <Col span={6} style={{ margin: '0 0 8px 0' }}>
                        <ComponentWithLabelLarge title={{ text: 'รอรับเข้าคลังจากใบ SO' }}>
                          <P color={theme.color.softPurple} bold>(+{value.quantity})</P><P margin='0 0 0 4px'>ชิ้น</P>
                        </ComponentWithLabelLarge>
                      </Col> */}
                    </Row>
                  </Div>
                ))
              }
              {
                // _.size([...new Array(5)]) - 1 !== i && <Divider />
                _.size([...new Array(5)]) - 1 !== i && <Wrapper />
              }
            </Div>
          ))
        }
      </Collapse>
    </Div>
  )
}

// Tire Type
const TireDetail = ({ data }) => {
  const [isOpenStock, setIsOpenStock] = useState(true)
  const [isOpenVariant, setIsOpenVariant] = useState(true)
  return (
    <Div>
      <Row type='flex' gutter={24} style={{ marginBottom: 16 }}>
        <Col xs={24} md={24} lg={24} xl={14} xxl={10}><PartImage src={(_.size(data.inventoryOptions) > 0 && data.inventoryOptions[0].url) ? data.inventoryOptions[0].url : imageNotAvailable} alt='' /></Col>
        <Col xs={24} md={24} lg={24} xl={10} xxl={14}><Info data={data}/></Col>
      </Row>
      <AttributesList data={data}/>
      <Tags data={data}/>
      <StockCollapse isOpenStock={isOpenStock} setIsOpenStock={setIsOpenStock} stockLocations={_.size(data.inventoryOptions) > 0 ? data.inventoryOptions[0].stockLocation : []}/>
      <Collapse open={isOpenVariant} text='แพ็คสินค้า' onClick={() => setIsOpenVariant(!isOpenVariant)} fullHeight={true} margin='8px 0'>
        {
          _.size(data.inventoryOptions) > 0 && data.inventoryOptions[0].pack.map((v, i) => (
            <Div key={i}>
              <H4 bold margin='0 0 8px 0'>{v.name}</H4>
              <Row type='flex' gutter={16}>
                <Col span={8} style={{ margin: '0 0 8px 0' }}>
                  <LargeTextWithLabel title={{ text: 'ราคาซื้อสุทธิ' }} content={{ text: `${numeral(v.salesPrice).format('0,0.00')} บาท` }} />
                </Col>
                <Col span={8} style={{ margin: '0 0 8px 0' }}>
                  <LargeTextWithLabel title={{ text: 'ราคาขาย' }} content={{ text: `${numeral(v.salesPrice).format('0,0.00')} บาท` }} />
                </Col>
              </Row>
              {
                _.size([...new Array(5)]) - 1 !== i && <Divider />
              }
            </Div>
          ))
        }
      </Collapse>
    </Div>
  )
}

export default ({ props }) => {
  const { loading: infoLoading, data: infoData, error: infoError } = useQuery(INVENTORY, { variables: { id: parseInt(props.match.params.id, 10) } })
  if (infoLoading && _.isUndefined(infoData)) return <Loading center='true' />
  const { data } = infoData.inventoryInfo
  return <VariantDetail data={data}/>
}
